import React from 'react';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';

export const WebLayout = ({ children }) => {
  return (
    <div className="font-louis-george min-h-screen relative">
      {/* Soft Gold Ambient Glow */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-0 left-0 h-72 w-72 rounded-full bg-[#F3C72C]/5 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-[#F3C72C]/5 blur-[100px]" />
      </div>

      {/* NAVBAR */}
      <Navbar />

      {/* PAGE CONTENT */}
      <main className="px-4 md:px-12 max-w-fit mx-auto py-2">{children}</main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};
